// extracted by mini-css-extract-plugin
export default {"block":"block___Qkaih","FUploadImageChildren":"FUploadImageChildren___oxoXu","cover":"cover___uncGE","coverEdit":"coverEdit___bAIKm","btn":"btn___u1MAO"};